<template>
    <div class="sortBySelectDirection">
        <div :id="col" v-if="!$store.getters.isMobile" class="orderArrow" :class="[isAsc ? 'asc' : 'desc', isActive ? 'highlight' : '']">
            &#10094;
        </div>
        <div v-else :class="[isActive ? 'highlight' : '']">
            {{ sortDirectionText }}
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'col',
            'reverse'
        ],
        data() {
            return {
                active: false
            }
        },
        computed: {
            isActive() {
                if(this.$store.getters.isMobile) {
                    return (this.col == this.$store.getters.getSortColumn && this.reverse == this.$store.getters.getSortDirection);
                }

                return this.col == this.$store.getters.getSortColumn;
            },
            isAsc() {
                let ascending = !this.$store.getters.getAvailablSortColumnByName(this.col).defaultDirectionDesc;
                
                if(this.$store.getters.isMobile && this.reverse != null) {
                    ascending = !this.reverse;
                }
                else if(this.isActive) {
                    ascending = !this.$store.getters.getSortDirection;
                }

                return ascending;
            },
            sortDirectionText() {
                return this.isAsc ? this.col == 'year' ? "Oldest" : "Lowest" : this.col == 'year' ? "Newest" : "Highest";
            }
        }
    }
</script>

<style>
    .sortBySelectDirection {
        height: calc(1.5 * var(--vh));
        width: calc(1.5 * var(--vh));
        /*border-radius: 5px;*/
        margin: calc(.3 * var(--vh));
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .inmobile .sortBySelectDirection {
        height: inherit;
        width: fit-content;
    }

    .orderArrow {
        transition: transform 2s;
    }

    .asc {
        transform: rotate(90deg);
    }

    .desc {
        transform: rotate(-90deg);
    }

    .highlight {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
</style>